import React from 'react'
import { BASE_URL, FEMALE_DR_AVATAR, MALE_DR_AVATAR } from '../../configurations/initUrls'
import { MdOutlineAccessTime, MdOutlineAddLocationAlt, MdPhoneInTalk } from 'react-icons/md'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { FaHospitalUser } from 'react-icons/fa'

export default function DoctorsCard({ item, isCenter = false, center }) {
    return (
        item &&
        <Link to={isCenter? `/center/${center.id}`:`/doctor/${item.doctorId}`} className="max-w-sm mx-auto">
            <div className="flex flex-col justify-between bg-gradient-to-b from-brand-50 to-white p-6 shadow-xl hover:shadow-2xl transition-shadow h-full border-brand-400 border-t-4 rounded-3xl">
                <div className="flex items-center gap-4">
                    {item.isDP == 0 ?
                        <img className="h-14 w-14 rounded-full ring-2 ring-brand-200/60 object-cover" src={item.gender === 0 ? MALE_DR_AVATAR : FEMALE_DR_AVATAR} alt="Doctor Image" />
                        :
                        <img className="h-14 w-14 rounded-full ring-2 ring-brand-200/60 object-cover" src={BASE_URL + "/" + item.dpUrl} alt="Doctor Image" />
                    }
                    <div>
                        <h3 className="text-brand-900 font-semibold leading-tight">Dr. {item.fullName}</h3>
                        <p className="text-brand-700/80 text-sm">{item.specialisation.name} ({item.specialisation.shortName}), {item.degree}</p>
                    </div>
                </div>

                <p className="mt-4 text-brand-900/80 text-sm flex flex-col">
                    {isCenter &&
                        <>
                            <span class="text-sm text-gray-700 flex gap-1">
                                <div><div className='pt-1'><FaHospitalUser className='text-red-500' /></div></div>
                                <div>{center.centerName}</div>
                            </span>
                            <span class="text-sm text-gray-700 flex gap-1">
                                <div><div className='pt-1'><MdOutlineAccessTime className='text-lime-500' /></div></div>
                                <div>Time: {moment(new Date(center.opdStartTime)).format("LT")} to {moment(new Date(center.opdEndTime)).format("LT")}</div>
                            </span>
                            <span class="text-sm text-gray-700 flex gap-1">
                                <div><div className='pt-1'><MdPhoneInTalk className='text-green-500' /></div></div>
                                <div>{center.phone} | <span className='text-xs'>Exp.</span> {item.experiance} {item.experiance > 1 ? "years" : "year"}</div>
                            </span>
                        </>
                    }
                    {!isCenter &&
                        <>
                            <span class="text-sm text-gray-700 flex gap-1">
                                <div><div className='pt-1'><MdPhoneInTalk className='text-green-500' /></div></div>
                                <div>{item.userName} | <span className='text-xs'>Exp.</span> {item.experiance} {item.experiance > 1 ? "years" : "year"}</div>
                            </span>

                            <span class="text-sm text-gray-700 flex gap-1 ">
                                <div><div className='pt-1'><MdOutlineAddLocationAlt className='text-blue-500' /></div></div>
                                <div> {item.address}, {item.city.name}</div>
                            </span>
                        </>
                    }
                    {isCenter &&
                        <span class="text-sm text-gray-700 flex gap-1 ">
                            <div><div className='pt-1'><MdOutlineAddLocationAlt className='text-blue-500' /></div></div>
                            <div> {center.address}, {center.city.name}</div>
                        </span>
                    }
                </p>

                <div className="mt-5 flex items-center justify-center gap-3">
                    <Link to={`/doctor/${item.doctorId}`}
                        className="inline-flex items-center rounded-xl bg-brand-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-400"
                    >
                        Take Appointment
                    </Link>
                </div>
            </div>
        </Link>
    )
}
